import React from 'react';

type LineTitleProps = {
    title: string;
    textSize?: string;
};

const LineTitle = ({ title, textSize = 'text-2xl' }: LineTitleProps) => {
    return (
        <div className="flex items-center justify-between">
            <p style={{ fontFamily: "Din condensed", whiteSpace: "nowrap" }} className={`mr-4 ${textSize}`}>{title}</p>
            <div className="border-[#d3d3d3] w-full border-t"/>
        </div>
    );
};

export default LineTitle;